{
  "GENERAL": {
    "CLOSE": "Luk",
    "SHOWING_RESULTS": "Showing {firstIndex}-{lastIndex} of {totalCount} items",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Søg",
      "EMPTY_STATE": "Ingen resultater fundet"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Mindst {count} påkrævet"
  }
}
